import React from "react";
import { ArrowRight, ChevronDown, MapPin } from "lucide-react";
import { Button } from "./ui/button";
import { heroData } from "../data/mock";
import { Logo } from "./Logo";

export const Hero = () => {
  const scrollToSection = (href) => {
    const element = document.querySelector(href);
    if (element) {
      element.scrollIntoView({ behavior: "smooth" });
    }
  };

  return (
    <section className="relative min-h-screen flex items-center justify-center overflow-hidden">
      {/* Background with Technical Drawing */}
      <div className="absolute inset-0">
        {/* Base color */}
        <div className="absolute inset-0 bg-primary" />
        {/* Technical drawing as overlay - MORE VISIBLE */}
        <div 
          className="absolute inset-0 opacity-30"
          style={{
            backgroundImage: `url("/images/hero-geruest.png")`,
            backgroundSize: 'cover',
            backgroundPosition: 'center right',
            backgroundRepeat: 'no-repeat',
            filter: 'invert(1)',
          }}
        />
        {/* Gradient overlay for depth */}
        <div className="absolute inset-0 bg-gradient-to-r from-primary/90 via-primary/70 to-primary/40" />
      </div>

      {/* Content */}
      <div className="relative z-10 max-w-7xl mx-auto px-4 sm:px-6 lg:px-8 pt-24 pb-16">
        <div className="max-w-4xl">
          {/* Badge */}
          <div className="inline-flex items-center gap-2 bg-white/10 backdrop-blur-md border border-white/20 rounded-full px-4 py-2 mb-8">
            <span className="w-2 h-2 bg-accent rounded-full animate-pulse" />
            <span className="text-white text-sm font-medium">
              Seit 2010 – Für das Baugewerbe
            </span>
          </div>

          {/* Headline */}
          <h1 className="text-4xl sm:text-5xl lg:text-6xl font-bold text-white leading-tight mb-6 drop-shadow-lg">
            {heroData.headline}
          </h1>

          {/* Subline */}
          <p className="text-xl sm:text-2xl text-white/90 mb-10 max-w-2xl leading-relaxed drop-shadow-md">
            {heroData.subline}
          </p>

          {/* CTAs */}
          <div className="flex flex-col sm:flex-row gap-4 mb-16">
            <Button
              onClick={() => scrollToSection(heroData.primaryCta.href)}
              className="bg-accent hover:bg-accent/90 text-neutral-900 font-semibold px-8 py-6 text-lg group shadow-lg"
            >
              {heroData.primaryCta.label}
              <ArrowRight className="w-5 h-5 ml-2 group-hover:translate-x-1 transition-transform" />
            </Button>
            <Button
              onClick={() => scrollToSection(heroData.secondaryCta.href)}
              variant="outline"
              className="border-2 border-white/40 text-white hover:bg-white/20 hover:text-white px-8 py-6 text-lg backdrop-blur-sm"
            >
              {heroData.secondaryCta.label}
            </Button>
          </div>

          {/* Trust indicators - clearer language */}
          <div className="flex flex-wrap gap-8 items-center">
            <div className="flex items-center gap-3 bg-black/30 backdrop-blur-md rounded-xl px-4 py-3">
              <div className="w-12 h-12 rounded-lg bg-accent/20 flex items-center justify-center">
                <span className="text-2xl font-bold text-accent">15+</span>
              </div>
              <div className="text-sm">
                <div className="font-semibold text-white">Jahre Erfahrung</div>
                <div className="text-white/80">im Gerüstbau</div>
              </div>
            </div>
            <div className="flex items-center gap-3 bg-black/30 backdrop-blur-md rounded-xl px-4 py-3">
              <div className="w-12 h-12 rounded-lg bg-accent/20 flex items-center justify-center">
                <MapPin className="w-6 h-6 text-accent" />
              </div>
              <div className="text-sm">
                <div className="font-semibold text-white">Deutschland & Italien</div>
                <div className="text-white/80">Für Baufirmen & Gerüstbauer</div>
              </div>
            </div>
          </div>
        </div>
      </div>

      {/* Scroll indicator */}
      <button
        onClick={() => scrollToSection("#leistungen")}
        className="absolute bottom-8 left-1/2 -translate-x-1/2 text-white/70 hover:text-white transition-colors animate-bounce"
        aria-label="Nach unten scrollen"
      >
        <ChevronDown className="w-8 h-8" />
      </button>
    </section>
  );
};
